import * as React from 'react'

import {
  Box,
  Chevron,
  LazyToggleMethod,
  Text,
  useToggle,
} from '@factorialco/deprecated-design-system'

import styles from './index.module.css'

const Row = ({ children }: React.PropsWithChildren<{}>) => (
  <Box
    paddingY="s16"
    paddingX="s24"
    justifyContent="spaceBetween"
    alignItems="center"
    flexDirection="row"
    border={{
      top: {
        style: 'solid',
        width: 's1',
        color: 'darker080',
      },
    }}
  >
    {children}
  </Box>
)

interface PaymentTextProps {
  label: string
  smallLabel?: string
}

const PaymentText = ({ label, smallLabel }: PaymentTextProps) => {
  return (
    <Box width="full" flexDirection="column">
      <Text size="300" color="grey800">
        {label}
      </Text>
      {smallLabel && (
        <Text size="200" color="grey600">
          {smallLabel}
        </Text>
      )}
    </Box>
  )
}

interface PaymentValueProps {
  amount?: string
  strokedAmount?: string | null | undefined
}

const PaymentValue = ({
  amount,
  strokedAmount,
  children,
}: React.PropsWithChildren<PaymentValueProps>) => {
  return (
    <Box width="full" alignItems="flexEnd">
      {strokedAmount && (
        <Text size="300" color="grey600" stroked>
          {strokedAmount}
        </Text>
      )}
      {amount && (
        <Text size="300" color="grey800">
          {amount}
        </Text>
      )}

      {children}
    </Box>
  )
}

interface TitleProps {
  title: string
  open: boolean
  toggle: LazyToggleMethod
}

const PaymentTitle = ({ title, open, toggle }: TitleProps) => {
  return (
    <Box padding="s16">
      <div onClick={toggle(!open)} className={styles.title}>
        <Text.Header3>{title}</Text.Header3>
        <Chevron direction={open ? 'up' : 'down'} type="primary" size="big" />
      </div>
    </Box>
  )
}

interface Props {
  title: string
}

const PaymentBill = ({ title, children }: React.PropsWithChildren<Props>) => {
  const [open, toggle] = useToggle(true)

  return (
    <div className={styles.bill}>
      <PaymentTitle title={title} open={open} toggle={toggle} />
      {open && <Box flexDirection="column">{children}</Box>}
    </div>
  )
}

PaymentBill.Row = Row
PaymentBill.Text = PaymentText
PaymentBill.Value = PaymentValue

export default PaymentBill
